import React, { useState, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Dropzone from 'react-dropzone-uploader';
import { userActions } from '../../redux/actions/user.actions';
import './DocumentsComponent.styles.scss';
import DocumentsTable from './DocumentsTable';

const OtherDocumentsComponent = () => {
  const dispatch = useDispatch();
  const companyProfile = useSelector((state) => state.companyProfile);
  const otherDocuments = useSelector((state) => state.companyOtherDocuments);
  const [isLoading, setIsLoading] = useState(false);

  const { items: companyOtherDocuments = [] } = otherDocuments || {};
  const { items } = companyProfile || {};
  const { company } = items || {};
  const { ACN: companyACN } = company || {};

  useEffect(() => {
    if (companyACN) {
      dispatch(userActions.getCompanyOtherDocuments(companyACN))
    }
  }, [dispatch, companyACN]);

  const handleChangeStatus = ({ file, remove }, status) => {
    if (status === 'done') {
      const formData = new FormData();
      formData.append('file', file);
      if (file) {
        setIsLoading(true);
        dispatch(userActions.postCompanyOtherDocuments(companyACN, formData, setIsLoading));
        remove();
      }
    } else if (status === 'error') {
      // you can surface a toast here
      // console.error("File upload failed:", file);
    }
  };

  const handleDelete = ({ FileName }) => {
    dispatch(userActions.deleteCompanyOtherDocuments(companyACN, FileName))
  };

  const handleDownload = ({ FileName }) => {
    dispatch(userActions.downloadCompanyOtherDocuments(companyACN, FileName, setIsLoading))
  };

  const hasFiles = useMemo(() => companyOtherDocuments.length > 0, [companyOtherDocuments]);

  return (
    <div className="odc-wrap">
      {isLoading && (
        <div className="odc-loading-overlay" aria-live="polite" aria-busy="true">
          <div className="odc-spinner" />
        </div>
      )}

      <div className="odc-grid" role="list">
        {hasFiles && (
          <DocumentsTable
            data={{
              loading: false,
              items: companyOtherDocuments,
              total: companyOtherDocuments.length,
            }}
            isLoading={isLoading}
            onDownload={(doc) => handleDownload(doc)}
            onDelete={(doc) => handleDelete(doc)}
          />
        )}
        <div className="odc-tile" role="listitem">
          <div className="odc-dropzone-tile">
            <Dropzone
              onChangeStatus={handleChangeStatus}
              inputContent={(
                <div className="odc-dropzone-content">
                  <div className="odc-upload-icon" />
                </div>
              )}
              styles={{
                dropzone: { border: '0', background: 'transparent' },
                inputLabel: { fontSize: 14, color: '#6b7280' },
                inputLabelWithFiles: { fontSize: 14, color: '#6b7280' },
                previewsContainer: { display: 'none' },
                submitButtonContainer: { display: 'none' },
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default OtherDocumentsComponent;